<div>
  <div [ngClass]="!readOnly ? '' : 'read-only-tags'">
    <mat-form-field class="example-chip-list example-full-width" [appearance]="appearance">
      <mat-chip-list
        #chipList
        [formControl]="controlObject"
        aria-label="Tags"
        [required]="isRequired()"
      >
        <mat-chip
          [ngStyle]="{ 'background-color': highlightTag ? '#f5ebc4' : '' }"
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="3"
          *ngFor="let tag of tagList"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(tag)"
        >
          {{ getTagDescription(tag) }}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
      <mat-label *ngIf="!this.readOnly"> Tags </mat-label>
      <div *ngIf="canAddComponent">
        <input
          *ngIf="!this.readOnly"
          #tagInput
          (ngModelChange)="tagInputChanged($event)"
          [(ngModel)]="tagValue"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="false"
          (matChipInputTokenEnd)="add($event)"
        />
      </div>
      <div *ngIf="!canAddComponent">
        <ng-template ngxPermissionsOnly="accessToTagsModule">
          <div *ngIf="canAddComponent">
            <input
              *ngIf="!this.readOnly"
              #tagInput
              (ngModelChange)="tagInputChanged($event)"
              [(ngModel)]="tagValue"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false"
              (matChipInputTokenEnd)="add($event)"
            />
          </div>

          <div *ngIf="!canAddComponent">
            <ng-template ngxPermissionsOnly="canAddTags">
              <input
                *ngIf="!this.readOnly"
                #tagInput
                (ngModelChange)="tagInputChanged($event)"
                [(ngModel)]="tagValue"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="false"
                (matChipInputTokenEnd)="add($event)"
              />
            </ng-template>
            <ng-template ngxPermissionsExcept="canAddTags">
              <input
                *ngIf="!this.readOnly"
                #tagInput
                (ngModelChange)="tagInputChanged($event)"
                [(ngModel)]="tagValue"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="false"
              />
            </ng-template>
          </div>
        </ng-template>
        <ng-template ngxPermissionsExcept="accessToTagsModule">
          <ng-template ngxPermissionsOnly="canAddTags">
            <input
              *ngIf="!this.readOnly"
              #tagInput
              (ngModelChange)="tagInputChanged($event)"
              [(ngModel)]="tagValue"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false"
              (matChipInputTokenEnd)="add($event)"
            />
          </ng-template>
          <ng-template ngxPermissionsExcept="canAddTags">
            <input
              *ngIf="!this.readOnly"
              #tagInput
              (ngModelChange)="tagInputChanged($event)"
              [(ngModel)]="tagValue"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false"
            />
          </ng-template>
        </ng-template>
      </div>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
          <span>{{ getTagDescription(tag) }}</span>
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="isRequired() && controlObject.touched && controlObject.hasError('required')"
        >Required field</mat-error
      >
    </mat-form-field>
  </div>
</div>
